import {
    BuildingModalIcon, ContractorTitle,
    EmployeesIcon,
    SuppliersIcon
} from '../../../../../components/buttons/IconButtons';
import React from 'react';
import { USER_TYPE_MODEL } from '../../../../../enums/userTypeEnum';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
export const RESERVATION_MODEL = {
    id: null,
    name: null,
    isHost: true,
    zoneSelected: null, // step 2
    dateSelected: null, // step 2
    bookingSelected: null, // step 2
    isValid: function () {
        return this.name != '';
    },
    isValidStepDetails: function (){
        return this.name != null;
    },
    isValidStepLocation: function (){
        return this.bookingSelected != null;
    },
    toAddEdit: function () {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            code: this.code,
            measurementUnitId: this.measurementUnitId
        }
    }
}

export const TABS_USER_TYPE = [
    {
        id: USER_TYPE_MODEL.EMPLOYEE,
        key: USER_TYPE_MODEL.EMPLOYEE,
        translation: "employee",
        icon: <EmployeesIcon className="btn-icon-svg-20px icon-color-shades-400" />,
        textNoInfo : "search_for_employees"
    },
    {
        id: USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
        key: USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
        translation: "Contractor",
        icon: <ContractorTitle className="btn-icon-svg-20px icon-color-shades-400" />,
        textNoInfo : "search_for_contractors"
    },
    {
        id: USER_TYPE_MODEL.SUPPLIER_IN_CHARGE,
        key: USER_TYPE_MODEL.SUPPLIER_IN_CHARGE,
        translation: "Suppliers",
        icon: <SuppliersIcon className="btn-icon-svg-20px icon-color-shades-400" />,
        textNoInfo : "search_for_suppliers"
    },
    {
        id: USER_TYPE_MODEL.VISITOR,
        key: USER_TYPE_MODEL.VISITOR,
        translation: "Visitor",
        icon: <BuildingModalIcon className="btn-icon-svg-20px icon-color-shades-400" />,
        textNoInfo : "search_for_visitors"
    },
];

export const TABS_USER_TYPE_MODEL = {
    EMPLOYEE: TABS_USER_TYPE[0],
    CONTRACTOR: TABS_USER_TYPE[1],
    SUPPLIER: TABS_USER_TYPE[2],
    VISITOR: TABS_USER_TYPE[3],
}

export const getUserTypeCounts = (usersSelected) => {
    const counts = {
        EMPLOYEE: 0,
        VISITOR: 0,
        CONTRACTOR_IN_CHARGE: 0,
        SUPPLIER_IN_CHARGE: 0
    };

    usersSelected.forEach(user => {
        switch (user.userTypeId) {
            case USER_TYPE_MODEL.EMPLOYEE:
                counts.EMPLOYEE++;
                break;
            case USER_TYPE_MODEL.VISITOR:
                counts.VISITOR++;
                break;
            case USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE:
                counts.CONTRACTOR_IN_CHARGE++;
                break;
            case USER_TYPE_MODEL.SUPPLIER_IN_CHARGE:
                counts.SUPPLIER_IN_CHARGE++;
                break;
            default:
                break;
        }
    });

    return counts;
};


export const getTextNoInfoByKey = (key) => {
    const tab = TABS_USER_TYPE.find(item => item.key === key);
    return tab ? tab.textNoInfo : null;
};

export const getUserTypeName = (id, list) => {
    const found = list.find(item => item.id === id);
    return found ? found.name : '';
};

export const STEPS_CREATE_RESERVATIONS = {
    DETAILS: {
        INDEX: 0,
        TRANS: "details",
    },
    SCHEDULE_LOCATION: {
        INDEX: 1,
        TRANS: "schedule_location",
    },
    ATTENDEES_TYPES: {
        INDEX: 2,
        TRANS: "attendees_types",
    },
    SUMMARY: {
        INDEX: 3,
        TRANS: "summary",
    }
}
